import {
  IconHome2,
  IconLogout,
  IconMenu2,
  IconUserCircle,
} from "@tabler/icons-react";
import { MediaQuery, Tooltip } from "@mantine/core";

import { horizontalBarStyles } from "./styles";
import { signOut } from "next-auth/react";
import { useRouter } from "next/router";
import { useWindowScroll } from "@mantine/hooks";

export interface HorizontalBarProps {
  props?: {
    title: string;
    path: Array<string>;
    state?: boolean;
    callBack?: Function;
  };
}

export const HorizontalBar = ({ props }: HorizontalBarProps) => {
  const router = useRouter();

  const [scroll] = useWindowScroll();
  const { classes } = horizontalBarStyles();

  return (
    <div
      className={`${classes.horizontalBar} ${
        scroll.y > 0 ? classes.sticked : ""
      }`}
    >
      <div>
        <div className={`${classes.path} softText`}>
          <IconHome2 style={{ width: "15px", paddingTop: "10px" }} />
          {props.path
            .map((i, k) => {
              if (k != props.path.length - 1) return `${i} `;
            })
            .join("/ ")}
          <span> {props.path ? props.path[props.path.length - 1] : ""} </span>
        </div>
        <div className={classes.title}>{props.title}</div>
      </div>
      <MediaQuery
        query="(max-width: 600px)"
        styles={{ marginLeft: "auto", padding: "0 20px" }}
      >
        <div
          className={`${classes.toggleSideBar} ${
            props.state ? classes.toggled : ""
          }`}
          onClick={() => props.callBack()}
        >
          <IconMenu2 />
          <div className={classes.iconAddorment}></div>
        </div>
      </MediaQuery>
      <MediaQuery query="(max-width: 600px)" styles={{ display: "none" }}>
        <div className={classes.optionsBar}>
          {/* <Tooltip
            label="Perfil"
            position="bottom"
            onClick={() => router.push("/profile")}
          >
            <a>
              <IconUserCircle className={classes.svg} />
            </a>
          </Tooltip> */}
          <Tooltip
            label="Sair"
            position="bottom"
            onClick={() => router.push("/profile")}
          >
            <a>
              <IconLogout
                onClick={() => {
                  signOut({ callbackUrl: `${process.env.BASE_URL}/login` });
                }}
                className={classes.svg}
              />
            </a>
          </Tooltip>
        </div>
      </MediaQuery>
    </div>
  );
};
